import styled from '@emotion/styled';
import { useMemoizedFn } from 'ahooks';
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { useTranslate } from '@tolgee/react';
import { useGetRegionLabel } from 'hooks/business/useRegion';

const RegionAllCheckbox = styled(Checkbox)`
  position: relative;
  &:before {
    content: '';
    position: absolute;
    width: 1px;
    height: 80%;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    background: #e7e7e7;
  }
`;

export interface RegionSelectProps {
  readonly?: boolean;
  regionRange: General.UpperCaseRegion[];
  value?: General.UpperCaseRegion[];
  onChange?: (val: General.UpperCaseRegion[]) => void;
  onSelect?: (val: General.UpperCaseRegion[]) => void;
}

export const RegionSelect = (props: RegionSelectProps) => {
  const { readonly, regionRange, value = [], onChange, onSelect } = props;
  const { t } = useTranslate();
  const getRegionLabel = useGetRegionLabel();

  const handleAllChange = useMemoizedFn((e: CheckboxChangeEvent) => {
    const selected = e.target.checked ? regionRange : [];
    onChange?.(selected);
    onSelect?.(selected);
  });

  const handleSingleChange = useMemoizedFn((e: CheckboxChangeEvent) => {
    const { checked, value: checkValue } = e.target;
    const selected = checked ? [...value, checkValue] : value.filter((v) => v !== checkValue);
    onChange?.(selected);
    onSelect?.(selected);
  });

  return (
    <>
      <RegionAllCheckbox
        disabled={readonly}
        indeterminate={value.length > 0 && value.length !== regionRange.length}
        checked={value.length === regionRange.length}
        onChange={handleAllChange}
      >
        {t('review.全部')}
      </RegionAllCheckbox>
      {regionRange.map((r) => (
        <Checkbox
          disabled={readonly}
          checked={value?.includes(r)}
          value={r}
          onChange={handleSingleChange}
        >
          {getRegionLabel(r)}
        </Checkbox>
      ))}
    </>
  );
};
